'use client';
import { OnbForm } from '@/components/form';
import { connectedField } from '@/redux/fields';
import { Grid, Stack, Typography } from '@mui/material';
import { productCodesConst, reviewAndSubmit, salesChannelsConst } from '@repo/onb-api';
import { Checkbox, COLORS } from '@repo/ui';
import { formatter } from '@repo/utils';
import { useRef, useState } from 'react';
import StepWrapper from './stepWrapper';

export default function ReviewAndSubmitCommerce({
  stepname: stepName,
  stepdata: stepData,
}: {
  stepname: reviewAndSubmit['name'];
  stepdata?: reviewAndSubmit['variables'];
}): React.JSX.Element {
  const {
    // termsAndConditions,
    tradeName,
    legalName,
    taxpayerId,
    firstName,
    lastName,
    mobilePhoneNumber,
    email,
    fiscalAddress,
    salesChannel,
    productCodes,
  } = stepData || {};

  const [termsState, setTermsState] = useState(false);
  const termsRef = useRef<HTMLButtonElement | null>(null);
  const termsError = termsRef.current?.className?.includes('checkboxError') ?? false;

  return (
    <StepWrapper>
      <OnbForm<reviewAndSubmit> stepName={stepName!} submitLabel="Confirmar" submitBlacklist={['termsAndConditions']}>
        <Stack gap={1}>
          <Typography variant="h1">Estamos a un paso de dar de alta tu comercio</Typography>
          <Typography variant="h2">Por favor revisá que tus datos sean los correctos</Typography>
        </Stack>
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: COLORS.background[0],
            borderRadius: 2,
            gap: 2,
            p: 2,
          }}
        >
          <Stack>
            <Typography variant="body3">Comercio</Typography>
            <Typography variant="h2">{tradeName}</Typography>
            <Typography variant="subtitle1">{legalName}</Typography>
            <Typography variant="subtitle1">{formatter(taxpayerId, 'cuit')}</Typography>
          </Stack>
        </Grid>
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: COLORS.background[0],
            borderRadius: 2,
            gap: 2,
            p: 2,
          }}
        >
          <Stack>
            <Typography variant="body3">Representante legal</Typography>
            <Typography variant="h2">{`${firstName} ${lastName}`}</Typography>
            <Typography variant="subtitle1">{email}</Typography>
            <Typography variant="subtitle1">{formatter(mobilePhoneNumber, 'phone')}</Typography>
          </Stack>
        </Grid>
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: COLORS.background[0],
            borderRadius: 2,
            gap: 2,
            p: 2,
          }}
        >
          <Stack>
            <Typography variant="body3">Dirección</Typography>
            <Typography variant="h2">{fiscalAddress}</Typography>
          </Stack>
        </Grid>
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: COLORS.background[0],
            borderRadius: 2,
            gap: 2,
            p: 2,
          }}
        >
          {salesChannel && (
            <Stack>
              <Typography variant="body3">Tipo de tienda</Typography>
              <Typography variant="h2">{salesChannelsConst[salesChannel]}</Typography>
            </Stack>
          )}
        </Grid>
        {productCodes && (
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: COLORS.background[0],
              borderRadius: 2,
              gap: 2,
              p: 2,
            }}
          >
            <Stack>
              <Typography variant="body3">Producto</Typography>
              <Typography variant="h2">
                {productCodes.map((code) => (code ? productCodesConst[code] : '')).join(', ')}
              </Typography>
            </Stack>
          </Grid>
        )}
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: '8px !important',
            px: 1,
            borderColor: !termsState && termsError ? COLORS.state.error : 'rgba(0, 0, 0, 0.23)',
          }}
        >
          <Checkbox
            ref={(el) => {
              termsRef.current = el;
            }}
            border="none"
            {...connectedField({
              checkbox: true,
              stepName,
              name: 'hasTermsAccepted',
              required: true,
              beforeChange: (value) => {
                setTermsState(!!value);
                return !!value;
              },
              errorHandler: {
                type: 'checkbox',
              },
            })}
          />
          <Typography variant="body2" color="primary" py={1}>
            Declaro que he leído y acepto los
            <br />
            <a
              href="https://cdn.pro.directo.com.ar/assets/documents/Solicitud+de+incorporacio%CC%81n+como+comercializador+de+servicios+de+DIRECTO+SA.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontWeight: 'bold' }}
            >
              Términos y Condiciones
            </a>
          </Typography>
        </Stack>
        {!termsState && termsError && (
          <Typography variant="body2" sx={{ textAlign: 'center' }} color="error">
            Marcá la casilla para continuar
          </Typography>
        )}
      </OnbForm>
    </StepWrapper>
  );
}
